import {
  FETCH_COMPLAIN,
  FETCH_COMPLAIN_SUCCESS,
  FETCH_COMPLAIN_FAILED,
  EDIT_COMPLAIN
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, push, set, query, orderByChild, equalTo } from "firebase/database";

export const fetchComplain = () => async (dispatch, getState) => {
  const { complainRef } = firebase;
  const db = firebase.database;
  const state = typeof getState === 'function' ? getState() : store.getState();
  const profile = state?.auth?.profile;
  const userRole = profile?.usertype;
  const uid = profile?.uid || firebase?.auth?.currentUser?.uid;
  const isAdmin = userRole === "admin" || userRole === "fleetadmin";

  dispatch({
    type: FETCH_COMPLAIN,
    payload: null,
  });

  const parseArray = (data) => {
    if (!data || typeof data !== 'object') return [];
    return Object.keys(data).map(i => {
      data[i].id = i;
      return data[i];
    }).sort((a, b) => (b.complainDate || b.date || 0) - (a.complainDate || a.date || 0));
  };

  // 1. Chargement direct et résilient via REST
  try {
    const { getValidAuthToken } = require("./authactions");
    const token = await getValidAuthToken();
    if (token) {
      const baseUrl = (firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
      const urls = [];
      if (isAdmin) {
        urls.push(`${baseUrl}/complain.json?auth=${token}`);
      } else if (uid) {
        urls.push(`${baseUrl}/userComplaints/${uid}.json?auth=${token}`);
        urls.push(`${baseUrl}/complain.json?auth=${token}&orderBy=%22uid%22&equalTo=%22${uid}%22`);
      }

      for (const rtdbUrl of urls) {
        try {
          const res = await fetch(rtdbUrl);
          if (res.ok) {
            const data = await res.json();
            if (data && typeof data === 'object' && Object.keys(data).length > 0) {
              const arr = parseArray(data);
              dispatch({
                type: FETCH_COMPLAIN_SUCCESS,
                payload: arr
              });
              break;
            }
          }
        } catch (_) {}
      }
    }
  } catch (restErr) {
    console.warn('[fetchComplain] REST load warning:', restErr.message);
  }

  // 2. Écouteur temps réel via SDK Database
  const { ref: dbRef } = require("firebase/database");
  let targetRef = null;
  if (isAdmin) {
    targetRef = complainRef;
  } else if (uid) {
    targetRef = db && dbRef ? dbRef(db, `userComplaints/${uid}`) : (complainRef ? query(complainRef, orderByChild("uid"), equalTo(uid)) : null);
  }

  if (!targetRef) return;

  onValue(targetRef, (snapshot) => {
    if (snapshot.val()) {
      const arr = parseArray(snapshot.val());
      dispatch({
        type: FETCH_COMPLAIN_SUCCESS,
        payload: arr
      });
    } else {
      // If userComplaints is empty for non-admin, try fallback query once
      if (!isAdmin && complainRef && uid) {
        try {
          const fallbackRef = query(complainRef, orderByChild("uid"), equalTo(uid));
          onValue(fallbackRef, (fbSnap) => {
            if (fbSnap.val()) {
              dispatch({
                type: FETCH_COMPLAIN_SUCCESS,
                payload: parseArray(fbSnap.val())
              });
            } else {
              dispatch({ type: FETCH_COMPLAIN_SUCCESS, payload: [] });
            }
          }, { onlyOnce: true });
        } catch (_) {}
      } else {
        dispatch({
          type: FETCH_COMPLAIN_SUCCESS,
          payload: []
        });
      }
    }
  }, (error) => {
    console.warn('[fetchComplain] onValue error:', error.message);
    dispatch({
      type: FETCH_COMPLAIN_FAILED,
      payload: error.message
    });
  });
};

export const editComplain = (reasons, method) => async (dispatch) => {

  const {
    complainRef,
    editComplainRef
  } = firebase;

  dispatch({
    type: EDIT_COMPLAIN,
    payload: { method, reasons }
  });

  if (method === 'Add') {
    let pushed = false;
    let newKey = null;
    if (complainRef) {
      try {
        const pushRes = await push(complainRef, reasons);
        pushed = true;
        newKey = pushRes?.key;
      } catch (err) {
        console.warn('[editComplain] Add push failed, attempting REST fallback:', err.message);
      }
    }
    if (!pushed) {
      try {
        const { getValidAuthToken } = require("./authactions");
        const idToken = await getValidAuthToken();
        if (idToken) {
          const baseUrl = (firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
          const postRes = await fetch(`${baseUrl}/complain.json?auth=${idToken}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(reasons)
          });
          if (postRes.ok) {
            const resData = await postRes.json();
            newKey = resData?.name;
          }
        }
      } catch (restErr) {
        console.warn('[editComplain] REST Add failed:', restErr.message);
      }
    }

    // Mirror to userComplaints immediately
    if (reasons?.uid) {
      try {
        const { ref: dbRef, set: dbSet } = require("firebase/database");
        const key = newKey || new Date().getTime().toString();
        const userCompEntry = { ...reasons, id: key };
        if (firebase.database && dbRef && dbSet) {
          await dbSet(dbRef(firebase.database, `userComplaints/${reasons.uid}/${key}`), userCompEntry);
        }
      } catch (_) {}
    }
  }
  else if (method === 'Update') {
    const updatedData = { ...reasons, processDate: new Date().getTime() };
    let updated = false;
    if (editComplainRef) {
      try {
        await set(editComplainRef(reasons.id), updatedData);
        updated = true;
      } catch (err) {
        console.warn('[editComplain] Update set failed, attempting REST fallback:', err.message);
      }
    }
    if (!updated && reasons.id) {
      try {
        const { getValidAuthToken } = require("./authactions");
        const idToken = await getValidAuthToken();
        if (idToken) {
          const baseUrl = (firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
          await fetch(`${baseUrl}/complain/${reasons.id}.json?auth=${idToken}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedData)
          });
        }
      } catch (restErr) {
        console.warn('[editComplain] REST Update failed:', restErr.message);
      }
    }
  }
};


